'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.weeks;


// WEBPACK FOOTER //
// ./~/sugar-date/number/weeks.js